function fmtDate(iso: string): string {
  try { return new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }); }
  catch { return iso?.slice(0, 10) || ""; }
}

export function ContractGate({ saved, draftName, onOpen, onNew, onNewArchitecture, onContinue, onSample, onHome }: {
  saved: { name: string; savedAt: string }[];
  draftName?: string;
  onOpen: (name: string) => void;
  onNew: () => void;
  onNewArchitecture: () => void;
  onContinue: () => void;
  onSample: () => void;
  onHome: () => void;
}) {
  return (
    <div className="landing landing--ready gate">
      <div className="ld-main">
        <header className="ld-head">
          <div className="ld-brand brand-home" onClick={onHome} title="Back to the studio home">Studio<span className="ld-dot2"> · </span>Contract</div>
          <button className="ld-signin" onClick={onHome}>← Studio home</button>
        </header>

        <div className="gate-hero">
          <div className="gate-kicker">Contract Studio</div>
          <h1 className="ld-title gate-title">Open a contract,<br />or start fresh.</h1>
          <p className="ld-lede">Start a new contract — construction or architecture — continue a saved one, or resume your current draft.</p>
        </div>

        <div className="gate-new">New contract</div>
        <div className="gate-actions">
          <button className="ld-card ld-card--portal" style={{ ["--i" as any]: 0 }} onClick={onNew}>
            <span className="ld-card-no">⌂</span>
            <span className="ld-card-body"><span className="ld-card-title">Construction contract</span><span className="ld-card-desc">Employer–Contractor agreement for building works — FIDIC Red Book or AIA A101, with payment, retention and site letters.</span></span>
            <span className="ld-card-arrow">→</span>
          </button>
          <button className="ld-card ld-card--portal" style={{ ["--i" as any]: 1 }} onClick={onNewArchitecture}>
            <span className="ld-card-no">✎</span>
            <span className="ld-card-body"><span className="ld-card-title">Architecture contract</span><span className="ld-card-desc">Our design-services appointment with a client — Owner–Architect agreement (AIA B101), with fee basis and work stages. We're pre-filled as the Architect.</span></span>
            <span className="ld-card-arrow">→</span>
          </button>
        </div>

        <div className="gate-actions" style={{ marginTop: 14 }}>
          {draftName && (
            <button className="ld-card" style={{ ["--i" as any]: 2 }} onClick={onContinue}>
              <span className="ld-card-no">⏱</span>
              <span className="ld-card-body"><span className="ld-card-title">Continue draft</span><span className="ld-card-desc">Resume “{draftName}” where you left off.</span></span>
              <span className="ld-card-arrow">→</span>
            </button>
          )}
          <button className="ld-card" style={{ ["--i" as any]: 3 }} onClick={onSample}>
            <span className="ld-card-no">◆</span>
            <span className="ld-card-body"><span className="ld-card-title">Start from sample</span><span className="ld-card-desc">A fully worked FIDIC Red Book contract to adapt.</span></span>
            <span className="ld-card-arrow">→</span>
          </button>
        </div>

        {saved.length > 0 && (
          <div className="gate-saved">
            <div className="ld-choose">Your saved contracts · {saved.length}</div>
            <div className="gate-list">
              {saved.map((s, i) => (
                <button key={s.name} className="gate-item" style={{ ["--i" as any]: i }} onClick={() => onOpen(s.name)}>
                  <span className="gate-item-name">{s.name}</span>
                  <span className="gate-item-date">{fmtDate(s.savedAt)}</span>
                  <span className="gate-item-arrow">→</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
